<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <v-select
                  :items="filteredLevelOptions"
                  v-model="academicLevel"
                  label="Cấp"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <v-select
                  :items="filteredGradeOptions"
                  v-model="grade"
                  label="Khối"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <div class="d-flex justify-end">
                  <v-btn
                    class="search-button"
                    :class="{ 'px-2': windowWidth < 1100 }"
                    @click="onFilterChanged"
                    outlined
                    :disabled="!this.grade"
                  >
                    Tìm kiếm
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    show: false,
    status: 'active',
    title: '',
    code: '',
    subjectGroup: '',
    academicLevel: '',
    grade: '',
    windowWidth: window.innerWidth,
    levelOptions: [
      // { name: 'Cấp 2', value: 'secondary' },
      { name: 'Cấp 3', value: 'high' },
    ],
    gradeOptions: [
      // { name: 'Khối 6', value: '6', level: 'secondary' },
      // { name: 'Khối 7', value: '7', level: 'secondary' },
      // { name: 'Khối 8', value: '8', level: 'secondary' },
      // { name: 'Khối 9', value: '9', level: 'secondary' },
      { name: 'Khối 10', value: '10', level: 'high' },
      { name: 'Khối 11', value: '11', level: 'high' },
      { name: 'Khối 12', value: '12', level: 'high' },
    ],
  }),
  props: {
    defaultFilters: Object,
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    ...mapState('grade', ['query']),
    ...mapState('auth', ['role', 'profile']),
    filteredLevelOptions() {
      // if (this.grade) {
      //   const selectedGrade = this.gradeOptions.find(grade => grade.value === this.grade)
      //   if (selectedGrade) {
      //     return this.levelOptions.filter(level => level.value === selectedGrade.level)
      //   }
      // }
      return this.levelOptions
    },
    filteredGradeOptions() {
      // if (this.academicLevel) {
      //   return this.gradeOptions.filter(grade => grade.level === this.academicLevel)
      // }
      if (this.role.type === 'teacher') {
        const allowedGrades = this.profile.ownClasses.map(x => x.gradeNumber.toString())
        return this.gradeOptions.filter(x => allowedGrades.includes(x.value))
      }
      return this.gradeOptions
    },
  },
  watch: {
    academicLevel(newVal) {
      if (newVal) {
        const selectedGrade = this.gradeOptions.find(grade => grade.value === this.grade)
        if (selectedGrade && selectedGrade.level !== newVal) {
          this.grade = ''
        }
      }
    },
    grade(newVal) {
      if (newVal) {
        const selectedGrade = this.gradeOptions.find(grade => grade.value === newVal)
        if (selectedGrade && selectedGrade.level !== this.academicLevel) {
          this.academicLevel = selectedGrade.level
        }
      }
    },
  },
  methods: {
    ...mapActions({}),
    onFilterChanged() {
      const query = {
        grade: this.grade,
      }
      this.$emit('onFilterChanged', query)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
}
</style>
